import React from 'react'
import '@/static/style/margin.less'
import {Steps, Input, Select, DatePicker,Popover,Upload,
  Button, Table, Modal, message,Alert,Spin, Tabs,Form} from 'antd'
import { PlusOutlined,UploadOutlined } from '@ant-design/icons'
import common from '@/public/common'
import '../returnGoods/index.less'
import {ajaxApi, downloadApi, fileDownloadApiNew} from '@/server'
import axios from 'axios'
import { summation, getCookie, getCookieNew, getParmUrl, outformat,outputMoney,tokenConfig } from '../../public/utils'
import _, { get,set } from 'lodash'
import moment from 'moment'
import { getSendErrColumns } from './config'

const { Step } = Steps
const { Option } = Select
const { TabPane } = Tabs
const urlLink = common.scpUrl + 'change-stack'
var api = common.scpUrl
class WaitBuyOrderDetails extends React.Component {
  constructor (props) {
    // const form = Form.useForm()
    super(props)
    this.form = null;
    this.state = {
      sping: false,
      uploading: false,
      row: [],
      data: [],
      pageNo: 0,
      pageSize: 15,
      total: 0,
      info: null,
      search: {},
      express: [],
      whid: [],
      exportData: [],
      errvisible: false,
      errDataList: [],
      actionSatus: '',
      downloadErrLoading:false,
      uploadFile:null,
      visibleObj:{'importIn':false},
      loading:{'uploadBtn':false},
      sendGoodVisible:false,
      //订单信息
      orderInfo:{}
    },
    this.exportErrorAxios = _.debounce(this.exportErrorAxios,1000)
  }
  componentDidMount () {
    this.getDetails()
    this.getList()
  }
  // 查询订单详情
   getDetails = async() => {
     let param = {
       POID: getParmUrl('POID'),
       s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null
     }
    
     ajaxApi({ // 获取详情的仓库信息
       url: urlLink + '/Purchase',
       params: {  action: 'getwarehousebypoid',data:{ PoID: getParmUrl('POID'),s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null} }
     }).then(res => {
        var is_supplier_delivery = get(res,'data.data.0.is_supplier_delivery')||false
        ajaxApi({ // 获取详情的仓库信息
          url: urlLink + '/Supplier',
          params: {   action: 'getdictionary',data:{Diction: 234},is_supplier_delivery  }
        }).then(expressres => {
          if (expressres.data.error_code === 0) {
            this.setState({
              express: expressres.data.data
            })
          } else {
            message.error(expressres.data.error_message)
          }
        })
       if (res.data.error_code === 0) {
         this.setState({
           whid: res.data.data
         })
       } else {
         message.error(res.data.error_message)
       }
     })
     ajaxApi({ // 获取订单状态
       url: urlLink + '/Purchase',
       params: { action: 'getpurchaseinfo',data:param}
     }).then(res => {
       if (res.data.error_code === 0) {
         this.setState({
           info: res.data.data
         })
       } else {
         message.error(res.data.error_message)
       }
     })
     try{
      let res = await ajaxApi({
        url:api+"poInfo/biz-status?po_code="+getParmUrl('code'),
        params:{}
      })
      this.setState({orderInfo:get(res,'data.data')})
    }catch(err){console.log(err)}
   }
   // 获取列表信息
   getList = () => {
     this.setState({
       sping: true
     }, () => {
       let param = {
         ...this.state.search,
         po_code: getParmUrl('code')
       }
       this.getListAxios(param)
     })
   }
   getListAxios=async(params)=>{
    try{
      let res = await ajaxApi({
        url:api+"poInfo/detail/collection",
        params
      })
      if(get(res,'status')==200){
        const data = get(res,'data.data').map((item)=>{
          return {
            ...item,
            send_quantity: item.quantity - item.deliveryed_quantity,
            degree: item.degree ? item.degree.split(',') : [],
            astigmia: item.astigmia ? item.astigmia.split(',') : [],
            axial_position: item.axial_position ? item.axial_position.split(',') : [],
            contact_arc: item.contact_arc ? item.contact_arc.split(',') : [],
            is_conversion: item.is_conversion ? item.is_conversion.split(',') : [],
            custom_num: item.custom_num ? item.custom_num.split(',') : []
          }
        })
        this.setState({data})
      }
    }catch(err){console.log(err)}
    this.setState({sping:false})
   }
   // 搜索条件input框值更改
   inputChange = (name, val) => {
     let _obj = this.state.search
     _obj[name] = val.target.value
     this.setState({
       search: _obj
     })
   }
   // 搜索条件select框值更改
   selectChange = (name, val) => {
     let _obj = this.state.search
     _obj[name] = val
     this.setState({
       search: _obj
     })
   }
   // 表格内下拉框更改
   tableSelect = (index, name, val) => {
     let _obj = this.state.data
     _obj[index][name] = val
     let _row = this.state.row
     for (let i = 0; i < _row.length; i++) {
       if (_row[i].product_id === _obj[index].product_id) {
         _row[i] = _obj[index]
       }
     }
     this.setState({
       data: _obj,
       row: _row
     })
   }
   // 表格内输入框值获取
   tableValue = (index, name, e) => {
     let _obj = this.state.data
     if (name === 'need_delivery_quantity') {
       if (parseInt(e.target.value) > parseInt(_obj[index].quantity)) {
         message.error('发货数量不能大于货物数量')
         return false
       }
     }
     _obj[index][name] = e.target.value
     let _row = this.state.row
     for (let i = 0; i < _row.length; i++) {
       if (_row[i].product_id === _obj[index].product_id) {
         _row[i] = _obj[index]
       }
     }
     this.setState({
       data: _obj,
       row: _row
     })
   }
   // 表格内时间输入框获取
   tableTime = (index, name, val) => {
     let _obj = this.state.data
     _obj[index][name] = val
     let _row = this.state.row
     for (let i = 0; i < _row.length; i++) {
       if (_row[i].product_id === _obj[index].product_id) {
         _row[i] = _obj[index]
       }
     }
     this.setState({
       data: _obj,
       row: _row
     })
   }
   // 搜索
   search = () => {
     this.getList()
   }

    // 通知质量供应商发货单中存在效期问题的品
    sendNoticeFunc = async (code) => {
      try {
        const res = await ajaxApi({
          url: common.scpUrl + 'item/send-notice',
          params: {code}
        })
        if (res.status === 200) {
          this.setState({
            errvisible: false
          })
        }
      } catch (err) {
        this.setState({
          errvisible: false
        })
      }
    }

  openSendGoodModal = () => {
    if(!this.checkData()){
      //先校验
      return 
    }
    this.setState({
      sendGoodVisible:true
    })
  }

  checkData = () => {
    let { row, data } = this.state
    if (!get(row, 'length')) {
      message.error('请选择要发货的货品！')
      return false
    }
    for (let i = 0; i < row.length; i++) { // 循环中断只能用for 0.0
      let indexNum = _.findIndex(data, (item) => { return item.product_id === this.state.row[i].product_id })
      if (row[i].lot_way !== '2') { // 没有批次效期的不需要走批次效期校验
        if (!row[i].batch_no) {
          message.error('第' + (indexNum + 1) + '行批号为空')
          return false
        }
        if (!row[i].production_date) {
          message.error('第' + (indexNum + 1) + '行生产日期为空')
          return false
        }
        if (!row[i].expiry_date) {
          message.error('第' + (indexNum + 1) + '行失效日期为空')
          return false
        }
      }
      if (!row[i].need_delivery_quantity) {
        message.error('第' + (indexNum + 1) + '行本次发货数量为空')
        return false
      }
    }
    return true
  }

  sendGoodsConfirm=async()=>{
    try{
      let values = await this.form.validateFields()
     let {search} = this.state
      this.setState({
        search:{...search,...values}
      },()=>{this.sendGood(0)})
    }catch(err){console.log(err)}
  }

  closeSendGoodsModal=()=>{
    this.setState({
      sendGoodVisible:false
    })
    this.form&&this.form.setFieldsValue({send_company:null,send_code:null,expect_date:null})
  }
  


   // 发货
   sendGood = (num) => {
     let that = this
     let {row, search, data} = that.state
     that.setState({
       actionSatus: 'sendgood'
     })
     if (row.length > 0) {
       if (!search.send_company) {
         message.error('请选择快递公司！')
         return false
       }
       if (!search.send_code) {
         message.error('请填写快递单号！')
         return false
       }
       if (!search.expect_date) {
        message.error('请填写预计到货日期！')
        return false
       }
       for (let i = 0; i < row.length; i++) { // 循环中断只能用for 0.0
         let indexNum = _.findIndex(data, (item) => { return item.product_id === that.state.row[i].product_id })
         if (row[i].lot_way !== '2') { // 没有批次效期的不需要走批次效期校验
           if (!row[i].batch_no) {
             message.error('第' + (indexNum + 1) + '行批号为空')
             return false
           }
           if (!row[i].production_date) {
             message.error('第' + (indexNum + 1) + '行生产日期为空')
             return false
           }
           if (!row[i].expiry_date) {
             message.error('第' + (indexNum + 1) + '行失效日期为空')
             return false
           }
         }
         if (!row[i].need_delivery_quantity) {
           message.error('第' + (indexNum + 1) + '行本次发货数量为空')
           return false
         }
       }
       var sid = getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).sid : null
       //处理快递单号
       var logistics_code = get(search,'send_code')&&get(search,'send_code').split('，').join(',')
       let param = {
        sid,
        expect_date:get(search,'expect_date').valueOf(),
        logistics_name:get(search,'send_company'),
        logistics_code,
         admin_id: getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).user_id : null,
        is_commit: num || 0,
         details: row.map(item => {
           return {
            po_id: String(item.po_id),
            po_code:item.po_code,
            product_id: String(item.product_id),
            product_code: item.product_code,
            qty: item.need_delivery_quantity,
            mdrc: item.mdrc,
            production_date:item.production_date? moment(item.production_date).valueOf():null,
            expiry_date: item.expiry_date?moment(item.expiry_date).valueOf():null,
            batch_no: item.batch_no,
            box_number: item.box_number,
           }
         })
       }
       that.setState({
         sping: true,
         loading:!num?{...this.state.loading,['sendGood']:true}:{...this.state.loading,['confirm']:true,sendGood:false}
       }, () => {
        this.sendAxios(param,num)
       })
     } else {
       message.error('请选择要发货的货品！')
     }
   }

   sendAxios=async(params,num)=>{
    try {
      const result = await ajaxApi({
        url: api + 'supplier-delivery-scs/manual-create',
        params
      })
      var res = result.data
      if (res.code === 200) {
        message.success(res.message + '发货成功！')
        if (num === 1) {
          this.sendNoticeFunc(res.message)
        }
        ajaxApi({ // 获取订单状态
          url: urlLink + '/Purchase',
          params: { action: 'getpurchaseinfo',data:{POID: getParmUrl('POID'),s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null}  }
        }).then(res => {
          this.closeSendGoodsModal()
          if (res.data.error_code === 0) {
            this.setState({
              info: res.data.data
            }, () => {
              if (this.state.info.status_for_supplier_name === '待发货' || this.state.info.status_for_supplier_name === '部分发货' || this.state.info.status_for_supplier_name === '视客部分确认收货') {
                this.setState({
                  sping: false
                })
                setTimeout(() => {
                  window.location.reload()
                },200)
                // this.props.history.push('/waitBuyOrderDetails?POID=' + getParmUrl('POID') + '&code=' + getParmUrl('code'))
              } else {
                this.setState({
                  sping: false
                })
                this.props.history.push('/main/orderAdmin/buyOrderDetails?POID=' + getParmUrl('POID') + '&code=' + getParmUrl('code'))
              }
            })
          } else {
            message.error(res.data.error_message)
          }
        })
      } else {
        if (res.code==-2) {
          let _errDataList = res.data
          this.setState({
            errDataList: _errDataList,
            errvisible: true,
            sping: false
          })
        } else if(res.code==-3){
          this.setState({
            sping: false,
            visible:false,
          },()=>{
           Modal.warning({
             title: res.message,
           })
          })
        } else {
          message.error(res.message)
          this.setState({
            sping: false
          })
        }
      }
      this.setState({
        loading:!num?{...this.state.loading,['sendGood']:false}:{...this.state.loading,['confirm']:false,['sendGood']:false}
      })
    } catch (err) {
      this.closeSendGoodsModal()
      this.setState({
        errvisible: false,
        sping:false,
        loading:!num?{...this.state.loading,['sendGood']:false}:{...this.state.loading,['confirm']:false,['sendGood']:false}
      })
    }
   }
   // 下载模板
   exportXls = () => {
     if(!getParmUrl('POID')){
      message.error('没有单号,不可以下载发货明细')
      return
     }
    let param = {
      po_ids: [getParmUrl('POID')],
      sid: getCookie('supplierinfo')?JSON.parse(getCookie('supplierinfo')).sid:null,
      begin_time :null,
      end_time :null,
    }

    fileDownloadApiNew({
      url:api + 'supplier-delivery-scs/export-delivery',
      param,
      filename: getParmUrl('code') + '发货明细' + moment(new Date()).format('YYYYMMDD') + '.xls',
    })
    // downloadApi(
    //   api + 'supplier-delivery-scs/download-template',
    //   null,
    //   getParmUrl('code') + '发货明细' + moment(new Date()).format('YYYYMMDD') + '.xls',
    // )
   }
   // 关闭导入发货单弹框
   handleCancel = () => {
     this.setState({
       visible: false,
       exportData: [],
       errvisible: false,
       uploadErrVisbile:false,
      errCountArr:[],
      loading:{},
      sendGoodVisible:false,
     })
   }
   // 打印发货单
   print = () => {
     if (this.state.data.length > 0) {
       this.props.history.push('/main/orderAdmin/printOrder?POID=' + getParmUrl('POID') + '&WHID=' + this.state.data[0].whid)
     }
   }
  //  打印采购单
  printscm = () => {
    if (this.state.data.length > 0) {
      this.props.history.push('/main/differReport/scmorderprint?POID=' + getParmUrl('POID'))
    }
  }
   // 导入发货明细
   uploadYes = (num) => {
    let { uploadFile }= this.state
     if (uploadFile) {
       this.setState({
         uploading: true,
         loading:!num?this.state.loading:{...this.state.loading,['confirm']:true}
       }, () => {
         this.uploadAxios(uploadFile,num)
       })
     } else {
       message.error('请选择要导入的数据')
      this.setState({loading:{}})
     }
   }

   uploadAxios=async(uploadFile,num)=>{
      try {
        var admin_id = getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).user_id : null
        var sid = getCookie('supplierinfo')?JSON.parse(getCookie('supplierinfo')).sid:null
        var formdata = new FormData();
        // formdata.append("admin_id", admin_id);
        formdata.append("sid", sid);
        formdata.append("file", uploadFile);
        formdata.append("is_commit", num);
        formdata.append("po_code", getParmUrl('code'));

        let result = await axios({
          method: 'post',
          url: `${api}supplier-delivery-scs/import-delivery`,
          data: formdata,
          headers: {
            token: getCookieNew('scs_token') ||''
          },
          withCredentials: false
        })
        var res = result.data

        if(res.code==200){
          message.success( '发货成功！' + res.message)
          if (num === 1) {
            this.sendNoticeFunc(res.message)
          }
          this.setState({
            uploading: false,
            data: res.data||[]
          })
          setTimeout(() => {
            this.getDetails()
            this.getList()
          },200)
        }else if(res.code==-1&&get(res, 'data.length') > 0){ 
            this.setState({
              uploading: false,
              exportData: res.data,
              errvisible:num?false:this.state.errvisible,
              errCountArr: get(res, 'message') && get(res, 'message').split('-'),
              uploadErrVisbile: true,
            })
        } else if(res.code==-2&&get(res, 'data.length') > 0){
          this.setState({
              errDataList: res.data,
              uploading: false,
              errvisible: true
            })
        } else if(res.code==-3){
          this.setState({
            uploading: false,
          },()=>{
           Modal.warning({
             title: res.message,
           })
          })
        } else {
          message.error(res.message)
          this.setState({
            uploading: false
          })
        }
        this.setState({
          loading:{},
        })
      } catch (err) {
        console.log(err)
        this.setState({
          uploading: false,
          loading:{},
        })
      }
   }
   // 下载导入错误数据
   exportError = async() => {
    try{
      this.setState({
        downloadErrLoading:true
      })
      await this.exportErrorAxios()
    }catch(err){
      this.setState({
        downloadErrLoading:false
      })
    }
  }

  exportErrorAxios=async()=>{
    await downloadApi(
      api + 'supplier-delivery-scs/download-error',
      this.state.exportData,
      '发货导入错误日志' + moment(new Date()).format('YYYYMMDD') + '.xls',
    )
    this.setState({
      uploadErrVisbile:false,
      errCountArr:[],
      downloadErrLoading:false
    })
  }

   // 仍要提交
   handleSumbit=() => {
     if (this.state.actionSatus === 'sendgood') {
       this.sendGood(1)
     }
     if (this.state.actionSatus === 'importgood') {
       this.uploadYes(1)
     }
   }

   getIsCustom=()=>{
    var columnsArr = this.getColumns()
    if(getParmUrl("hasErpCode")){
     var arr = [
       {
        title: '定制片参数',
        dataIndex: 'customized_arg_list',
        align: 'left',
        width: '250px',
        render: (text, record) => (
          <div>{record && record.customized_arg_list ? record.customized_arg_list.map(e=>{
            return <div>{e}</div>
          }) : '--'}</div>
        )
      },
     ]
     columnsArr.splice(6,0,...arr)
    }
    return columnsArr
  }

  uploadFun = (e) => {
    let { visibleObj, loading } = this.state
    if (e.file) {
      this.setState({
        uploadFile: e.file,
        visibleObj: { ...visibleObj, 'importIn': false, },
        loading: { ...loading,'uploadBtn': true },
        actionSatus: 'importgood'
      }, () => {
        this.uploadYes(0)
      })
    }
  }

  getPersonProps = () => {
    return {
      name: 'file',
      headers:{...tokenConfig},
      data: (file) => {
        return { file }
      },
      accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      beforeUpload: file => {
        if (!['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(file.type)) {
          message.error('请上传excel文件！')
        }
        return ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(file.type) ? true : Upload.LIST_IGNORE;
      },
      customRequest: this.uploadFun,
    }
  }

  handleVisibleChange = (newVisible) => {
    let { visibleObj } = this.state
    this.setState({
      visibleObj: { ...visibleObj, 'importIn': newVisible }
    })
  }
  getSum=(key)=>{
    let { data } = this.state
    return summation(data.map(item => { return item[key]||0 }))||0
   }
   getColumns =()=>{
    let {orderInfo} = this.state
    const columns = [
      {
        title: '收货仓库',
        dataIndex: 'wh_name',
        align: 'center',
        width: '90px'
      },
     //  {
     //    title: '采购单号',
     //    align: 'left',
     //    dataIndex: 'POCode'
     //  },
      {
        title: '货品名称/货品编码',
        dataIndex: 'product_name',
        align: 'left',
        width: 180,
        render: (text,record) => (
          <span>
            {outformat(text)}<br/>
            {get(record,'product_code')}
          </span>
        )
      },
      {
        title: '注册证号',
        dataIndex: 'lstmdrc',
        render: (text, record, index) => (
          <Select style={{width: '100%', fontSize: '12px'}} value={record.mdrc} onSelect={this.tableSelect.bind(this, index, 'mdrc')}>
            {
              text.map(item => {
                return <Option key={item} value={item} title={item} style={{fontSize: '12px'}}>{item}</Option>
              })
            }
          </Select>
        )
      },
     //  {
     //    title: '明细数量',
     //    dataIndex: 'custom_num',
     //    align: 'left',
     //    render: (text) => (
     //      <span>
     //        {text.length !== 0 ? text.map((item, index) => {
     //          return (
     //            <div key={index}>{item}</div>
     //          )
     //        }) : '--'}
     //      </span>
     //    )
     //  },
     {
 title: '供应商货品编码',
        dataIndex: 'third_product_code',
     },
      {
        title: '单位',
        dataIndex: 'unit',
        align: 'center',
      },
      {
        title: '计价数量',
        dataIndex: 'price_quantity',
        align: 'right',
       width:60,
       render: (text) => outformat(text||0)
      },
      {
       title: '免费数量',
       dataIndex: 'free_quantity',
       align: 'right',
       width:60,
       render: (text) => outformat(text||0)
     },
      {
        title: '单价',
        dataIndex: 'po_price',
        align: 'right',
       render: (text) => outputMoney(text||0)
      },
      {
         title: '币种',
         dataIndex: 'base_money_type',
         render: (text) => (
           <span>{text||'--'}</span>
         )
       },
      {
        title: '金额',
        dataIndex: 'po_settlement_amount',
        align: 'right',
       render: (text) => outputMoney(text||0)
      },
      {
        title: '已发数量',
        dataIndex: 'deliveryed_quantity',
        align: 'left',
       width:60,
       render: (text) => outformat(text||0)
      },
       {
        title: '不再交货数量',
        dataIndex: 'short_closed_qty',
        align: 'left',
       width:100,
       render: (text) => outformat(text||0)
      },
    //  {
    //    title: 'UDI',
    //    dataIndex: 'udi',
    //    align: 'left',
    //    width:220,
    //    render: (text, record, index) => (
    //      <Input style={{width: '200px'}} onChange={this.tableValue.bind(this, index, 'udi')}/>
    //    )
    //  },
     {
       title: '批号',
       dataIndex: 'batch_no',
       align: 'left',
       with: '150px',
       render: (text, record, index) => (
         <Input style={{}} onChange={this.tableValue.bind(this, index, 'batch_no')}/>
       )
     },
      {
        title: '生产日期',
        dataIndex: 'production_date',
        align: 'left',
        render: (text, record, index) => (
          <DatePicker style={{width: '120px'}} onChange={this.tableTime.bind(this, index, 'production_date')}/>
        )
      },
      {
        title: '失效日期',
        dataIndex: 'expiry_date',
        align: 'left',
        render: (text, record, index) => (
          <DatePicker style={{width: '120px'}} onChange={this.tableTime.bind(this, index, 'expiry_date')}/>
        )
      },
      {
       title: '箱号',
       dataIndex: 'box_number',
       key: 'box_number',
       align: 'left',
       width:150,
       render: (text, record, index) => (
         <Input style={{width: '120px'}} value={record.box_number} onChange={this.tableValue.bind(this, index, 'box_number')}/>
       )
     },
      {
        title: '本次发货数量',
        dataIndex: 'need_delivery_quantity',
        align: 'left',
        width:120,
        render: (text, record, index) => (
          <Input style={{width: '110px'}} value={record.need_delivery_quantity} onChange={this.tableValue.bind(this, index, 'need_delivery_quantity')}/>
        )
      },
    ]
    var cloneData = _.cloneDeep(columns)
    if(!get(orderInfo,'full_delivery')){
     cloneData = this.setHide(cloneData, 'box_number')
    }
    return this.filterHide(cloneData)
   }

   setHide = (data, key) => {
    return _.cloneDeep(data).map(item => {
        if (get(item, 'key') == key) {
            set(item, 'hide', true)
        }
        return item
    })
}

  filterHide = (data) => {
        return _.filter(data, function (item) { return !get(item, 'hide') })
  }
   render () {
     const { data, total, sping, orderInfo, express, whid, info, uploading, exportData, errvisible, errDataList,loading,visibleObj
      ,errCountArr } = this.state
     const rowSelection = {
       // 分页选择项合并
       onChange: (selectedRowKeys, selectedRows) => {
         this.setState({
           row: selectedRows
         })
       },
       getCheckboxProps: (record) => ({
    disabled: !record.product_id,
  }),
     }
     const uploadButton = (
       <div style={{width: '80px', height: '80px', textAlign: 'center', border: '1px dashed', cursor: 'pointer', lineHeight: '80px'}}>
         <PlusOutlined style={{fontSize: '28px'}}/>
       </div>
     )
     return (
       <div className="returnList orderDetail">
         <Spin spinning={sping}>
           <div className="search">
             {
              get(orderInfo,'import_result')=='on'&&
              <Alert message="您导入的发货明细，系统正在紧急处理中，请稍候！" type="warning" showIcon />
             }
             <div style={{width: '60%', marginLeft: '20%',marginTop:16}}>
               <Steps progressDot current={2}>
                 <Step title="提交订单" />
                 <Step title="供应商确认订单" />
                 <Step title="供应商发货" />
                 <Step title="确认收货" />
                 <Step title="交易完成" />
               </Steps>
             </div>
           </div>
           <div className="returnBody">
             <h2 style={{fontSize: '22px'}}><span style={{fontWeight: 'bold'}}>订单状态：</span><span>{info? info.status_for_supplier_name : ''}</span>&nbsp;<span style={{fontWeight: 'bold'}}>订单编号：</span><span>{getParmUrl('code')}</span>
             </h2> 
             <Tabs type="card">
               <TabPane tab="货品详情" key="1">
                 <div className='mb16'>
                            收货地址：{whid.length > 0 ? whid[0].address + ',' + whid[0].real_name + ',' + whid[0].phone : ''}
                 </div>
                 <div className='mb16'>
                    货品编码：<Input style={{width: '200px', marginRight: '25px'}} onChange={this.inputChange.bind(this, 'product_code')} placeholder="货品编码"/>
                    货品名称：<Input style={{width: '200px', marginRight: '25px'}} onChange={this.inputChange.bind(this, 'product_name')} placeholder="货品名称"/>
                   <Button type="primary" shape="round" onClick={this.search} style={{marginRight: '25px'}}>查询</Button>
                   <Button type="primary" shape="round" 
                   onClick={this.openSendGoodModal} 
                   style={{marginRight: '25px'}}>发货</Button>
                   {
                     !['on', 'fail'].includes(get(orderInfo,'import_result')) &&
                     <Popover
                       content={
                         <div>
                           <Spin spinning={get(loading, 'uploadBtn') || false}>
                             <a onClick={this.exportXls}>
                               下载模板</a>
                             <span className={'noProgressUplaod'}>
                               <Upload {...this.getPersonProps()} >
                                 <Button className={'ml16'} icon={<UploadOutlined />}>Excel导入</Button>
                               </Upload>
                             </span>
                           </Spin>
                         </div>
                       }
                       title="发货明细导入"
                       trigger="click"
                       showCancel={true}
                       onVisibleChange={this.handleVisibleChange}
                       open={get(visibleObj, 'importIn') || false}
                     >
                       <Button
                         type="primary" shape="round"
                         className='mr24'
                         onClick={() => { this.setState({ visibleObj: { ...visibleObj, 'importIn': true } }) }}
                       >发货明细导入</Button>
                     </Popover>
                   }
                   <Button type="primary" shape="round" style={{marginRight: '25px'}} onClick={this.print}>打印发货单</Button>
                   <Button type="primary" shape="round" style={{marginRight: '25px'}} onClick={this.printscm}>打印采购单</Button>
                 </div>
                 <div className='mb12'>
                   <span className='sumInfo'>总数量：<span className='sumInfo_red'>{outformat(this.getSum('quantity'))}</span>
                   （计价：<span className='sumInfo_red' style={{marginRight:6}}>{outformat(this.getSum('price_quantity'))}</span>免费：<span className='sumInfo_red'>{outformat(this.getSum('free_quantity'))}</span>）</span>
                   <span className='sumInfo'>金额：<span className='sumInfo_red'>{outputMoney(this.getSum('po_settlement_amount'))}</span></span> 
                   <span className='sumInfo'>收货数量：<span className='sumInfo_red'>{outformat(this.getSum('receipt_quantity'))}</span></span></div>
                 <Table
                 className='littlePaddingTable'
                 bordered
                 columns={this.getIsCustom()}
                 dataSource={data}
                 rowSelection={rowSelection}
                 pagination={false}
                 rowKey={record => record.product_id}
                 />
               </TabPane>
             </Tabs>

             <Modal title={'实时导入结果'}
              destroyOnClose={true}
              open={this.state.uploadErrVisbile}
              onCancel={this.handleCancel}
              footer={[
              <Button shape="round" onClick={this.handleCancel}>关闭</Button>,
              <Button type="primary" shape="round" onClick={this.exportError} loading={this.state.downloadErrLoading}>数据诊断报告下载</Button>
              ]}>
              <Spin spinning={uploading}>
                <div>
                  <h3>导入数据异常，创建发货单失败！</h3>
                  <p>
                    模板数据：{get(errCountArr,0)||0}条/校验通过：{get(errCountArr,1)||0}条/
                    <span style={{color:'red'}}>校验失败：{get(errCountArr,2)||0}条</span>
                  </p>
                </div>
              </Spin>
            </Modal>

             <Modal title={<span style={{color: 'red', textAlign: 'center', display: 'inline-block', width: '100%'}}>填写有误，请核实！</span>}
               destroyOnClose={true}
               width={1400}
               scroll={{y: 500}}
               open={errvisible}
               onCancel={this.handleCancel}
               footer={[<Button type="primary" shape="round" onClick={this.handleSumbit} loading={get(loading,'confirm')}>仍要提交</Button>, <Button shape="round" onClick={this.handleCancel}>取消</Button>]}>
               <Spin spinning={uploading}>
                 <Table columns={getSendErrColumns()} dataSource={errDataList} className='littlePaddingTable'  pagination={false} rowKey={record => record.product_code}></Table>
                 {/* <div style={{marginTop: '16px', color: 'red'}}>出错原因：来货产品有效期与注册证产品有效期不符</div> */}
               </Spin>
             </Modal>

             <Modal title={'发货信息填写'}
              open={this.state.sendGoodVisible}
              onCancel={this.handleCancel}
              footer={[
              <Button shape="round" onClick={this.handleCancel}>取消</Button>,
              <Button type="primary" shape="round" onClick={this.sendGoodsConfirm} loading={get(loading,'sendGood')}>确定</Button>
              ]}>
               <Form
                 labelCol={{
                   span: 6,
                 }}
                 ref={(refs) => {
                   this.form = refs;
                 }}
                 wrapperCol={{
                   span: 16,
                 }}
               >
                 <Form.Item
                   name="send_company"
                   label="快递公司"
                   rules={[
                    {
                      required:true,
                    }
                   ]}
                 >
                  <Select allowClear style={{width: '200px', marginRight: '25px'}} placeholder="请选择" onSelect={this.selectChange.bind(this, 'send_company')}>
                     {
                       express.map(item => {
                         return <Option key={item.dict_key} value={item.dict_key}>{item.dict_name}</Option>
                       })
                     }
                   </Select>
                 </Form.Item>
                 
                 <Form.Item
                   name="send_code"
                   label="快递单号"
                   rules={[
                    {
                      required:true,
                      validator: async (rule, value) => {
                        if(!value||!value.trim()) { throw new Error('请输入快递公司!'); }
                      }
                    }
                   ]}
                 >
                 <Input style={{width: '200px', marginRight: '25px'}} placeholder="请输入" />
                 </Form.Item>
                 <Form.Item
                   name="expect_date"
                   label="预计到货日期"
                   rules={[
                    {
                      required:true,
                      validator: async (rule, value) => {
                        if (value&&moment(value).valueOf()<moment().startOf('day').valueOf()) { throw new Error('预计到货日期需大于等于上传日期!'); }
                        if(!value) { throw new Error('请选择预计到货日期!'); }
                      }
                    }
                   ]}
                 >
                   <DatePicker
                   style={{width:200}}
                     disabledDate={(current) => { return current && current < moment().startOf('day') }}
                   />
                 </Form.Item>
               </Form>
            </Modal>
           </div>
         </Spin>
       </div>
     )
   }
}
export default WaitBuyOrderDetails


// WEBPACK FOOTER //
// ./src/pages/orderAdmin/waitBuyOrderDetails.js